
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent implements OnInit {
  description: any;
  heading: any;
  notFromDoc: boolean = true
  forLink: any
  routes: any
  fromComp: any;
  timeSelected: any = 'Select time'
  btndis: boolean = true
  fromShop: boolean = false
  fromReturns: boolean = false
  type:any


  constructor(public constants: Constants,
    private ngxUiLoaderService: NgxUiLoaderService, public dialogRef: MatDialogRef<DeleteDialogComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.description = this.dataStore.description;
    this.fromComp = this.dataStore?.from
    console.log(this.dataStore.description);

    if (this.fromComp == 'DC') {
      this.notFromDoc = false
      this.forLink = this.dataStore.forlink
      this.routes = this.dataStore.routes
      console.log(this.routes, "this.routes");
    }
    if (this.fromComp == "ShopM") {
      this.fromShop = true
    }

    if (this.fromComp == 'fromReturns') {
      this.timeSelected = 'Select return time'
      this.fromReturns = true
      this.routes = this.dataStore.routes
      this.type = this.dataStore.type
      console.log(this.routes, "this.routes");
    }
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  public delete() {
    // this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    // this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
    this.dialogRef.close({
      event: "ConfirmEvent",
      // data : this.description
    });
  }
  public saveClick() {
    this.dialogRef.close({
      event: "ConfirmEvent",
      data: this.timeSelected
    });
  }

  setRouteValue(event: any) {
    if (this.timeSelected != '' || this.timeSelected != 'Select time' || this.timeSelected != 'Select return time') {
      this.btndis = false
    }

  }

}


